<template>
    <section class="title-screen parallax-parent" data-parallax="background" data-speed="1.5" id="home" data-anchor="home">

        <div class="video-container">
            <video autoplay="autoplay"
                   class="is-background"
                   ref="title_screen_background"
                   muted="muted"
                   data-parallax="block"
                   :data-speed="0.2"
            >

                <source src="https://excelsior-landing.s3.eu-west-2.amazonaws.com/media/title-screen.mp4" type="video/mp4">

            </video>
        </div>

        <h1>Best brokerage solutions for decentralized economy</h1>

        <div class="content">

            <p class="text">Brokerage service provider and trading platform for professional traders and institutional investors in the crypto assets market. Single connection to cryptocurrency exchanges and OTC, ability to trade and manage digital assets from a single interface with one multicurrency account</p>

            <button class="btn" @click="$parallax.scrollTo('getbeta')">sign up for beta</button>

        </div>

        <ParallaxBlock unique-class="title-screen_dotes"
                       :speed="-0.4"
                       image="dotes_11x19"
        >
        </ParallaxBlock>

        <ParallaxBlock unique-class="title-screen_circle"
                       :speed="-0.1"
                       image="Ellipse"
        >
        </ParallaxBlock>

        <ParallaxBlock unique-class="title-screen_circle_transparent"
                       :speed="-0.1"
                       image="Ellipse_transparent"
        >
        </ParallaxBlock>

    </section>
</template>

<script>
    export default {
        name: 'TitleScreen',
        mounted() {
            this.$refs['title_screen_background'].play()
        }
    }
</script>